var React = require('react');

function Location12x16 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.00085 8.11122C7.94762 8.11122 8.71513 7.31528 8.71513 6.33344C8.71513 5.3516 7.94762 4.55566 7.00085 4.55566C6.05407 4.55566 5.28656 5.3516 5.28656 6.33344C5.28656 7.31528 6.05407 8.11122 7.00085 8.11122Z","stroke":"#4B4E53","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7 17C7 17 13 12.6923 13 7.15385C13 5.52174 12.3679 3.95649 11.2426 2.80242C10.1174 1.64835 8.5913 1 7 1C5.4087 1 3.88258 1.64835 2.75736 2.80242C1.63214 3.95649 1 5.52174 1 7.15385C1 12.6923 7 17 7 17Z","stroke":"#4B4E53","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Location12x16.defaultProps = {"width":"14","height":"18","viewBox":"0 0 14 18","fill":"none"};

module.exports = Location12x16;

Location12x16.default = Location12x16;
